module.exports = __webpack_public_path__ + "img/contact.3b5e652c.png";